module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 9-54d81e80245eeb47f563f942de71da4c.webp";